import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=1df49714"
import script from "./userAgreement.vue?vue&type=script&lang=ts"
export * from "./userAgreement.vue?vue&type=script&lang=ts"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=1df49714&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports